module.exports = __webpack_public_path__ + "img/lietuvaskaito-original-480.f71737af.webp";